import { jsx as s } from "react/jsx-runtime";
import { s as t } from "../../../form-item.module-avu57bh1.js";
const a = ({
  id: r,
  children: o,
  ...m
}) => /* @__PURE__ */ s("div", { id: r, className: t["form-item__error"], ...m, children: o });
export {
  a as FormItemError
};
